module.exports = __webpack_public_path__ + "static/media/background.d07416d0.png";